import Phaser from 'phaser';

export const HERO_COMBAT_TEXTURE_KEY = 'exiled-knight-combat-v04';
export const HERO_PAUSE_TEXTURE_KEY = 'exiled-knight-pause-v04';

type SwordPose = 'held' | 'back';

export function ensureHeroTextures(scene: Phaser.Scene): void {
  if (!scene.textures.exists(HERO_COMBAT_TEXTURE_KEY)) {
    generateHeroTexture(scene, HERO_COMBAT_TEXTURE_KEY, 'held');
  }
  if (!scene.textures.exists(HERO_PAUSE_TEXTURE_KEY)) {
    generateHeroTexture(scene, HERO_PAUSE_TEXTURE_KEY, 'back');
  }
}

function generateHeroTexture(scene: Phaser.Scene, textureKey: string, swordPose: SwordPose): void {
  const hero = scene.add.graphics().setVisible(false);
  hero.fillStyle(0x000000, 0.42).fillEllipse(48, 117, 60, 14);

  if (swordPose === 'back') drawSwordOnBack(hero);

  // Рваный бордовый плащ отдельным крупным силуэтом.
  hero.fillStyle(0x2d171b, 1).fillTriangle(19, 42, 70, 43, 67, 111);
  hero.fillStyle(0x54262e, 1).fillPoints([
    { x: 20, y: 42 }, { x: 61, y: 46 }, { x: 63, y: 92 },
    { x: 53, y: 115 }, { x: 44, y: 99 }, { x: 34, y: 116 }, { x: 24, y: 92 },
  ], true);
  hero.fillStyle(0x71343d, 0.72).fillTriangle(23, 45, 40, 51, 32, 105);
  hero.lineStyle(2, 0x9a5455, 0.45).lineBetween(27, 49, 32, 98);

  // Отдельные поножи и тяжёлые сапоги сохраняют взрослые пропорции.
  hero.fillStyle(0x242a27, 1).fillRoundedRect(31, 85, 14, 29, 4);
  hero.fillRoundedRect(52, 84, 14, 30, 4);
  hero.fillStyle(0x515650, 1).fillRoundedRect(32, 87, 12, 19, 3);
  hero.fillRoundedRect(53, 86, 12, 19, 3);
  hero.lineStyle(2, 0x85867e, 0.6).lineBetween(34, 93, 42, 93);
  hero.lineBetween(55, 92, 63, 92);
  hero.fillStyle(0x171b19, 1).fillRoundedRect(27, 108, 20, 10, 4);
  hero.fillRoundedRect(50, 107, 20, 10, 4);

  // Узкий торс из кольчуги и несовпадающих ремонтированных пластин.
  hero.fillStyle(0x202522, 1).fillRoundedRect(25, 43, 47, 52, 8);
  hero.lineStyle(2, 0x656b65, 0.85).strokeRoundedRect(25, 43, 47, 52, 8);
  hero.fillStyle(0x454c47, 1).fillPoints([
    { x: 29, y: 45 }, { x: 48, y: 49 }, { x: 45, y: 79 }, { x: 29, y: 87 },
  ], true);
  hero.fillStyle(0x343a36, 1).fillPoints([
    { x: 49, y: 49 }, { x: 68, y: 45 }, { x: 68, y: 84 }, { x: 47, y: 79 },
  ], true);
  hero.lineStyle(2, 0x717771, 0.55).lineBetween(48, 50, 47, 79);
  hero.lineStyle(4, 0x251c18, 1).lineBetween(27, 77, 68, 82);
  hero.lineStyle(2, 0x9a5c3b, 0.85).lineBetween(29, 80, 67, 85);
  hero.fillStyle(0x211815, 1).fillCircle(48, 82, 4);

  // Руки и угловатые наплечники.
  hero.fillStyle(0x303633, 1).fillRoundedRect(15, 48, 14, 36, 5);
  hero.fillRoundedRect(69, 48, 13, 35, 5);
  hero.fillStyle(0x646a64, 1).fillPoints([
    { x: 12, y: 45 }, { x: 29, y: 40 }, { x: 34, y: 52 }, { x: 17, y: 59 },
  ], true);
  hero.fillStyle(0x4b514d, 1).fillPoints([
    { x: 65, y: 42 }, { x: 82, y: 46 }, { x: 79, y: 59 }, { x: 63, y: 53 },
  ], true);
  hero.lineStyle(2, 0x8d9188, 0.68).lineBetween(14, 47, 28, 43);
  hero.lineBetween(67, 44, 80, 48);
  hero.fillStyle(0x563323, 0.9).fillCircle(21, 49, 3);
  hero.fillCircle(75, 50, 2);
  hero.fillStyle(0x565c57, 1).fillRoundedRect(13, 76, 15, 12, 4);
  hero.fillRoundedRect(70, 75, 14, 12, 4);

  // Полностью закрытый вытянутый шлем.
  hero.fillStyle(0x171b19, 1).fillRoundedRect(29, 33, 38, 18, 7);
  hero.fillStyle(0x5d645f, 1).fillPoints([
    { x: 48, y: 9 }, { x: 63, y: 18 }, { x: 66, y: 39 },
    { x: 57, y: 49 }, { x: 38, y: 49 }, { x: 29, y: 39 }, { x: 32, y: 18 },
  ], true);
  hero.lineStyle(3, 0x8e9188, 0.88).strokePoints([
    { x: 48, y: 9 }, { x: 63, y: 18 }, { x: 66, y: 39 },
    { x: 57, y: 49 }, { x: 38, y: 49 }, { x: 29, y: 39 }, { x: 32, y: 18 },
  ], true);
  hero.fillStyle(0x242a27, 1).fillRect(31, 29, 33, 10);
  hero.lineStyle(2, 0xa4a297, 0.7).lineBetween(34, 32, 61, 32);
  hero.lineStyle(2, 0x101311, 1).lineBetween(34, 36, 61, 36);
  hero.lineStyle(3, 0x303632, 1).lineBetween(48, 11, 48, 47);
  hero.fillStyle(0x96998f, 0.82).fillTriangle(43, 11, 49, 3, 54, 13);
  hero.fillStyle(0x87472f, 0.82).fillCircle(59, 22, 3);
  hero.fillCircle(35, 41, 2);

  // Повреждённый знак прежнего ордена на груди.
  hero.lineStyle(3, 0xb49d63, 0.88).strokeCircle(47, 63, 9);
  hero.lineBetween(47, 51, 47, 75);
  hero.lineBetween(36, 63, 41, 61);
  hero.lineBetween(53, 67, 58, 63);
  hero.lineStyle(3, 0x221619, 1).lineBetween(39, 55, 55, 72);

  if (swordPose === 'held') drawSwordInHand(hero);

  hero.generateTexture(textureKey, 96, 128);
  hero.destroy();
}

function drawSwordOnBack(hero: Phaser.GameObjects.Graphics): void {
  hero.lineStyle(12, 0x252a27, 1).lineBetween(77, 16, 30, 105);
  hero.lineStyle(8, 0x626863, 1).lineBetween(75, 17, 31, 102);
  hero.lineStyle(2, 0xb0aca0, 0.75).lineBetween(72, 20, 32, 99);
  hero.fillStyle(0x777d76, 1).fillTriangle(82, 7, 78, 23, 69, 18);
  hero.lineStyle(7, 0x392a22, 1).lineBetween(23, 96, 37, 105);
  hero.lineStyle(5, 0x8e7755, 0.9).lineBetween(21, 91, 42, 103);
}

function drawSwordInHand(hero: Phaser.GameObjects.Graphics): void {
  // Клинок выводится поверх правой руки, чтобы оружие явно читалось как удерживаемое.
  hero.lineStyle(14, 0x1c211f, 1).lineBetween(76, 72, 88, 18);
  hero.lineStyle(9, 0x666d68, 1).lineBetween(76, 70, 88, 18);
  hero.lineStyle(2, 0xb8b5aa, 0.8).lineBetween(79, 67, 89, 19);
  hero.fillStyle(0x777d76, 1).fillTriangle(91, 5, 93, 22, 83, 19);
  hero.lineStyle(8, 0x27201a, 1).lineBetween(64, 72, 87, 78);
  hero.lineStyle(4, 0x9a825d, 0.95).lineBetween(64, 70, 88, 76);
  hero.lineStyle(7, 0x4a3023, 1).lineBetween(73, 76, 69, 94);
  hero.fillStyle(0xb09165, 1).fillCircle(68, 97, 5);
  hero.fillStyle(0x6a706a, 1).fillCircle(75, 75, 6);
  hero.fillStyle(0x565c57, 1).fillCircle(71, 84, 6);
}
